/** Public marketing paths for the design-partner site (shareable path routes). */
export const DESIGN_PARTNER_PATHS = {
  home: "/",
  howItWorks: "/how-it-works",
  product: "/product",
  roadmap: "/roadmap",
  faq: "/faq",
  apply: "/apply",
  access: "/access",
  privacy: "/privacy",
  terms: "/terms",
  security: "/security",
  contact: "/contact",
} as const;

export type DesignPartnerPath =
  (typeof DESIGN_PARTNER_PATHS)[keyof typeof DESIGN_PARTNER_PATHS];

export const DESIGN_PARTNER_PRIVACY_EMAIL = "info@getzephix.com";

/** Formspree form id for design-partner apply form. */
export const DESIGN_PARTNER_FORMSPREE_ID = "xeajgolg";
